import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { MandalaMotif } from "@/components/MotifBackground";
import { Flame, ArrowRight } from "lucide-react";

// Homepage promo banner inviting visitors to begin a daily Sadhana / Japa
// practice. Links to the Sadhana page.
export default function SadhanaBanner() {
  const { pick } = useLang();
  return (
    <section className="mx-auto max-w-7xl px-5 py-6 md:px-8">
      <Link
        to="/sadhana"
        data-testid="home-sadhana-banner"
        className="group relative flex flex-col gap-5 overflow-hidden border border-[var(--saffron)]/30 bg-[linear-gradient(135deg,rgba(199,80,0,0.06),rgba(198,138,0,0.05))] p-6 transition-all duration-500 hover:-translate-y-0.5 hover:border-[var(--saffron)] hover:shadow-[0_16px_50px_rgba(199,80,0,0.14)] md:flex-row md:items-center md:justify-between md:p-8"
      >
        <MandalaMotif className="pointer-events-none absolute -right-16 -top-10 h-56 w-56 text-[var(--saffron)] opacity-[0.07]" />
        <div className="relative z-[2] flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-[var(--saffron)]/40 bg-surface/70 text-saffron">
            <Flame className="h-6 w-6" />
          </span>
          <div className="max-w-xl">
            <p className="overline-label text-gold">{pick("नित्य साधना", "Daily Sadhana")}</p>
            <h2 className="mt-1.5 font-serif-latin text-2xl text-ink md:text-3xl">{pick("अपनी दैनिक साधना आरंभ करें", "Begin your daily Sadhana")}</h2>
            <p className="mt-2 text-[15px] leading-relaxed text-ink-2">
              {pick(
                "जप, मंत्र एवं नित्य अभ्यास से एक सुदृढ़ आध्यात्मिक नियम बनाएँ — प्रतिदिन की साधना एवं संख्या संजोएँ।",
                "Build a steady spiritual rhythm with japa, mantra and daily practice — track your sadhana and keep your streak alive.")}
            </p>
          </div>
        </div>
        <span className="relative z-[2] inline-flex shrink-0 items-center gap-2 self-start whitespace-nowrap border border-[var(--saffron)] bg-[var(--saffron)] px-6 py-3 text-sm font-medium text-white transition-colors group-hover:bg-[var(--saffron-dark)] md:self-auto">
          {pick("साधना आरंभ करें", "Start your practice")} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </span>
      </Link>
    </section>
  );
}
